import { useMutation } from "@apollo/client";
import { Box, Button, Dialog, DialogContent, DialogTitle, FormControl, Grid, IconButton, MenuItem, Select, Stack, Typography } from "@mui/material";
import { UPDATE_RENT_STATUS } from "../../Schema/StudentRent";
import { AuthContext } from "../../Context/AuthContext";
import { useContext, useState } from "react";
import { BiMinusCircle } from "react-icons/bi";

export default function UpdateStatusRent({ row , setRefetch }) {

    // 
    const { setAlert } = useContext(AuthContext);
    const [loading,setLoading] = useState(false);

    const [returnStatus,setReturnStatus] = useState(row?.returnStatus)
    
    // 
    const [open,setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // 
    const handleGetTranslate = (string) => {
        if(string === "not_yet_returned") {
            return "មិនទាន់ប្រគល់"
        }
        if(string === "lose_some") {
            return "បាត់"
        }
        if(string === "return_some") {
            return "ប្រគល់ខ្លះ"
        }
        if(string === "return") {
            return "ប្រគល់អស់"
        }  
        return string
    }

    const handleCheckColor = (string) => {
        if(string === "not_yet_returned") {
            return "red"
        }
        if(string === "lose_some") {
            return "red"
        }
        if(string === "return_some") {
            return "orange"
        }
        if(string === "return") {
            return "green"
        }  
        return string
    }

    // 
    const [updateRentMaterialStatus] = useMutation(UPDATE_RENT_STATUS,{
        onCompleted: ({updateRentMaterialStatus}) => {
            setLoading(false);
            if(updateRentMaterialStatus?.status) {
                setAlert(true, "success", updateRentMaterialStatus?.message);
                setRefetch();
                handleClose();
            } else {
                setAlert(true, "error", updateRentMaterialStatus?.message);
            }            
        },
        onError: (error) => {
            console.log(error.message)
            setLoading(false);
        }
    })
      

    const handleUpdate = () => {
        setLoading(true);
        // 
        updateRentMaterialStatus({
            variables:  {
                id: row?._id,
                input: {
                    returnStatus: returnStatus,
                }
            }
        })
    }

    return(
    <>
        <Button
            onClick={() => {
                handleOpen(); 
            }}
        >
                <Typography className="member-name" sx={{ color: handleCheckColor(row?.returnStatus) }}>
                    {handleGetTranslate(row?.returnStatus)}
                </Typography>
        </Button>


        <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
            <DialogTitle sx={{ padding: "10px 20px" }}>
                <Stack direction="row" spacing={2}>
                <Stack direction="column" justifyContent="center">
                    <Typography className="dialog-title">កែប្រែស្ថានភាព</Typography> 
                </Stack>

                <Box sx={{ flexGrow: 1 }} />
                <Stack direction="column" justifyContent="center">
                    <IconButton onClick={handleClose}>
                        <BiMinusCircle className="close-icon" />
                    </IconButton>
                </Stack>
                </Stack>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography className="field-title">ស្ថានភាពបច្ចុប្បន្ន</Typography>
                        <FormControl fullWidth size="small" className="search-field">
                            <Select
                                value={returnStatus}
                                onChange={(val) =>
                                    setReturnStatus(val.target.value )
                                } 
                            >
                                <MenuItem value="not_yet_returned">មិនទាន់ប្រគល់</MenuItem> 
                                <MenuItem value="lose_some">បាត់</MenuItem>
                                <MenuItem value="return_some">ប្រគល់ខ្លះ</MenuItem>
                                <MenuItem value="return">ប្រគល់អស់</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        {loading ? (
                            <Button className="btn-create" fullWidth>
                                កំពុងដំណើរការ...
                            </Button>
                        ) : (
                            <Button className="btn-create" fullWidth onClick={handleUpdate}>
                                កែប្រែ
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    </>
    )
}